import { useEffect, useState } from "react";

const MIN_IN_MS = 60 * 1000;
const HOUR_IN_MS = 60 * MIN_IN_MS;
const DAY_IN_MS = 24 * HOUR_IN_MS;

const getReturnValues = (countdown: number): Array<string> => {
  const hours = Math.floor((countdown % DAY_IN_MS) / HOUR_IN_MS);
  const minutes = Math.floor((countdown % HOUR_IN_MS) / MIN_IN_MS);
  const seconds = Math.floor((countdown % MIN_IN_MS) / 1000);

  return [
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(seconds).padStart(2, "0"),
  ];
};

export const useCountdown = (endsAt: Date): Array<string> => {
  const endTime = new Date(endsAt).getTime();
  const startTime = new Date().getTime();

  const initialTimeLeft = endTime - startTime;
  const initialState = initialTimeLeft > 0 ? initialTimeLeft : 0;
  const [countdown, setCountdown] = useState(initialState);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeLeft = endTime - currentTime;

      if (timeLeft >= 0) {
        setCountdown(timeLeft);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [endTime]);

  return getReturnValues(countdown);
};
